import React, { Component } from "react";
import {Auth} from "aws-amplify";
import Spacer from "../components/Spacer";
import * as prosConnect from "../prodect/ProsConnect"

import {USE_PRODUCTION_SERVER} from "../config";
import {isValidEmail, isValidPassWord} from "../prodect/ProsCommonUi";
import TextInput from "../components/TextInput";
import BasicButton from "../components/BasicButton";
import BasicModal from "../components/BasicModal";

export default class AuthLogin extends Component {
    constructor(props) {
        super(props)
        this._initState = {
            isLoading: false,
            email: prosConnect.getUserEmail(true) ? prosConnect.getUserEmail(true) : "",
            password: '',
            msgFin: '',
            msgEng: ''
        }
        this.state = this._initState
    }

    resetPage(){
        this.setState(this._initState)
        window.location.reload(false)
    }
    validateForm() {
        return isValidEmail(this.state.email) && isValidPassWord(this.state.password)
    }

    handleChange = (id, val) => {
        this.setState({
            [id]: val.trim(),
            msgFin: '',
            msgEng: ''
        })
    }

    handleKeyDown =(evt)=> {
        if (evt.key === 'Enter'){
            evt.preventDefault()
            this.handleSubmit()
        }
    }

    handleSubmit = async ()=> {
        this.setState({ isLoading: true })
        try {
            //Store state to var because sometimes state empties, especially on safari autosubmit
            const loginData = [this.state.email.trim(), this.state.password]
            await Auth.signIn(loginData[0], loginData[1])
            prosConnect.setUserEmail(loginData[0])
            this.props.userHasAuthenticated(true)
        } catch (e) {
            let msgFin = 'Virhe kirjautumisessa: '
            if (e.hasOwnProperty('code') && e.code === 'UserNotFoundException') {
                msgFin = 'Käyttäjätunnusta ei ole rekisteröity tai salasana väärin'
            }
            let msgEng = e.hasOwnProperty('message') ?  e.message : `${e}`
            console.log('Auth.signin failed: ', e);
            this.setState({
                isLoading: false,
                msgFin: msgFin,
                msgEng: msgEng,
            })
            BasicModal(msgFin, msgEng, {
                action: ()=> this.resetPage(),
                hideDismissButton: true
            })
        }
    }

    renderMessage(){
        if(this.state.msgFin === '' && this.state.msgEng === '') return
        return <div className={"msg msg-notice"}>
            <p>{this.state.msgFin}&nbsp;{this.state.msgEng}</p>
        </div>
    }

    render() {
        let loginPageTitle = USE_PRODUCTION_SERVER ?
            'Kirjautuminen'
            : 'Kirjautuminen Prodect TESTI serverille'

        return <div className="mini-page">
            <header>
                <h1>{loginPageTitle}</h1>
            </header>
            <section>
                <form onSubmit={(evt)=>{
                    evt.preventDefault()
                    this.handleSubmit()
                }}>
                    <TextInput
                        id={"email"}
                        name={"email"}
                        type="email"
                        label={"Sähköposti"}
                        required
                        isValid={isValidEmail(this.state.email, true)}
                        value={this.state.email}
                        onChange={val => this.handleChange('email', val)}
                        placeholder={"Sähköpostiosoite"}
                        onKeyDown={this.handleKeyDown}
                    />
                    <TextInput
                        id={"password"}
                        name={"password"}
                        label={"Salasana"}
                        type={"password"}
                        required
                        isValid={isValidPassWord(this.state.password)}
                        value={this.state.password}
                        onChange={val => this.handleChange('password', val)}
                        placeholder={"········"}
                        onKeyDown={this.handleKeyDown}
                    />
                    <div className={"btn-set_center"}>
                        <BasicButton
                            btnClass={"primary"}
                            icon={this.validateForm() || this.state.isLoading ? "check" : "outline-lock"}
                            label={"Kirjaudu"}
                            buttonType={"submit"}
                            disabled={!this.validateForm()}
                            loading={this.state.isLoading}
                        />
                    </div>
                </form>
                <Spacer size={"xl"}/>
                {this.renderMessage()}
            </section>
        </div>
    }
}
